// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N10s","buttons":"styles_buttons__1KJrY"};